import React from "react";
import ArticleCardBody from "../ArticleCardBody";
import ArticleCardBodyRow from "../ArticleCardBodyRow";
import ArticleCardHeader from "../ArticleCardHeader";
import LazyImage from "../LazyImage";
import { formatPrice } from "../helpers";

function isNull(x) {
  return x == null;
}

function getVal(x) {
  return isNull(x) ? "-" : x.valueDE;
}

export default function ArticleCard({
  showPrice,
  showUVP,
  isLoggedIn,
  articleID,
  brand,
  uvp,
  segment,
  material,
  frameType,
  shapeForm,
  color,
  isProgressive,
  lensWidth,
  bridgeWidth,
  templeLength,
  price,
  mediaDataLarge,
  artmemo
}) {
  return (
    <div className="w-full h-full bg-white rounded-sm shadow-blur-lg">
      <div
        className="flex items-center justify-center p-1"
        style={{
          height: "50%"
        }}
      >
        <LazyImage
          src={mediaDataLarge.jpgUrl}
          aspectRatio={
            mediaDataLarge.ratio === undefined ? 40 : mediaDataLarge.ratio * 100
          }
        />
      </div>
      <div
        style={{
          height: "45%"
        }}
        className="px-4 pt-6 overflow-y-scroll"
      >
        <ArticleCardHeader
          articleID={articleID}
          brand={brand}
          showPrice={showPrice}
          showUVP={showUVP}
          uvp={uvp}
          price={price}
          src={mediaDataLarge.jpgUrl}
          isLoggedIn={isLoggedIn}
        />
        <div className="pt-4">
          <ArticleCardBody>
            <ArticleCardBodyRow name="Segment" value={getVal(segment)} />
            <ArticleCardBodyRow
              name="Größe"
              value={`${lensWidth} - ${bridgeWidth} - ${templeLength}`}
            />
            <ArticleCardBodyRow name="Material" value={getVal(material)} />
            <ArticleCardBodyRow name="Farbe" value={color.colorDE} />
            {(Array.isArray(artmemo) || typeof artmemo === "string") &&
            artmemo.length ? (
              <ArticleCardBodyRow
                name="Beschreibung"
                value={artmemo.join("")}
              />
            ) : null}
            <ArticleCardBodyRow name="Fassungstyp" value={getVal(frameType)} />
            <ArticleCardBodyRow name="Fassungsform" value={getVal(shapeForm)} />
            <ArticleCardBodyRow
              name="Gleitsicht"
              value={isProgressive ? "ja" : "nein"}
            />
          </ArticleCardBody>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ArticleCard/ArticleCard.js